/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './../AuctionDetail.css';

import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import {useAuth} from "../../../data/userContext";

function BidsTable(props) {
    const auth = useAuth();

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        { field: 'price', headerName: 'Příhoz', valueFormatter: ({value}) => `${value} Kč`, width: 150 },
        { field: 'date', headerName: 'Datum', width: 200 },
        { field: 'user', headerName: 'Uživatel', width: 200 },
    ];


    function getContent() {
        if (!props.isLoaded) {
            return "";
        }

        if (props.auction.type === "OPEN" || props.auction.status === "CLOSED"
            || (auth.user.id === props.auction.ownerID || auth.user.id === props.auction.createByID) ) {
            return (
                <DataGrid autoHeight
                          pageSize={10}
                          rowsPerPageOptions={[10]}
                          disableSelectionOnClick
                          rows={props.bidRows}
                          columns={columns} />
            );
        }
        else {
            return (
                <Typography variant="h4" component="h4" align="center">
                    Aukce je uzavřená. Nelze vidět příhozy.
                </Typography>
            );
        }
    }

    return (
        <Paper elevation={6} sx={{ padding: 2,
            width: 1
        }}>
            {getContent()}
        </Paper>
    );
}


export default BidsTable;